import React from 'react';
import { useTranslation } from 'react-i18next';
import useTitle from '../comnon/title';
import WelcomeCard from './welcomeCard';
import CheckList from './checkList';

const Dashboard = () => {
    const { t } = useTranslation();
    useTitle(t('home.onboarding_view_title'));

   return (
       <>
          <WelcomeCard />
          <CheckList />
       </>

   );

};

export default Dashboard;
